var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameSeenLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 867,
    height: 530,
    viewBox: "0 0 867 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M866 483.386C846.836 497.21 794.022 525.799 767.258 528.313C733.803 531.454 667.678 524.46 631.13 494.074C530.394 410.324 551.552 290.489 536.935 194.666C526.685 127.465 512.014 82.7342 461.904 42.9204C407.336 -0.435551 344.54 -8.56132 277.737 11.1889C191.663 36.637 153.66 101.985 104.614 178.643C52.7807 259.658 1.00001 466.426 1.00001 466.426",
    stroke: "#999999",
    strokeOpacity: 0.5,
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameSeenLine);
export default __webpack_public_path__ + "static/media/name-seen-line.60f9f171ab41ed8bc4c9503aafbfcecc.svg";
export { ForwardRef as ReactComponent };